import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Terminals} from "../../../shared/interface/terminals";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {of, ReplaySubject} from "rxjs";
import {AuthService} from "../../../shared/services/auth.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {validIban} from "../../../shared/validator/iban-validator";
import {delay, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsService} from "../../../shared/services/terminals.service";

@Component({
  selector: 'app-terminals-details-form',
  templateUrl: './terminals-details-form.component.html',
  styleUrls: ['./terminals-details-form.component.scss']
})
export class TerminalsDetailsFormComponent implements OnInit, OnDestroy {
  @Input() terminalsObject?: Terminals;
  @Output() closeModification = new EventEmitter<any>();

  terminalForm: FormGroup;
  insuranceCompanyControl: FormControl;
  policyNumberControl: FormControl;
  accountNumberControl: FormControl;
  sumControl: FormControl;
  userPermissionss: ReplaySubject<UserPermissions>;
  processingRequest = false;
  formErrors: any = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private terminalsService: TerminalsService,
  ) {
    this.userPermissionss = auth.getUserPermissions();
    this.terminalForm = this.fb.group({
      insuranceCompany: this.insuranceCompanyControl = new FormControl( '', [Validators.required]),
      policyNumber: this.policyNumberControl =  new FormControl( '', [Validators.required]),
      accountNumber: this.accountNumberControl =  new FormControl('', [Validators.required , validIban()]),
      sum: this.sumControl =  new FormControl('', [Validators.required]),
    });
  }
  ngOnInit(): void {
    this.initialize(this.terminalsObject);
  }

  cancel(): void {
      this.closeModification.emit();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initialize(terminals: Terminals): void {
    of(terminals)
      .pipe(
        delay(0),
        tap(() => {
          this.terminalForm.reset({
            insuranceCompany: terminals.insuranceCompany?.id,
            policyNumber: terminals.policyNumber,
            accountNumber: terminals.accountNumber,
            sum: terminals.sum,
          });
        }),
        delay(0),
        tap(() => {
          this.initialized.next(true);
        })
      ).subscribe();
  }

  sendForm(): void {
    if ( !this.terminalForm.valid)
    {
      this.terminalForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;

    this.formErrors = {};

    this.terminalsService.edit(this.terminalForm.value, this.terminalsObject.uuid)
      .pipe(
        delay(0),
        tap(() => this.initialized.next(true))
      )
      .subscribe(() => {
        this.snackBar.open('Pomyślnie edytowano polisę', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        this.closeModification.emit();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snackBar.open('Podczas dodawania polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.terminalForm, this.formErrors);
        }
      })
    ;
  }
}
